import React from "react";
import { PRICING, pricingAmountLabel } from "../shared/pricingContent.js";

const PricingSection = ({ onOpenModal, entryOffer = null, catalogStatus = "ready" }) => {
  const amount = catalogStatus === "loading" ? "" : pricingAmountLabel(entryOffer);

  return (
    <section className="cursor-section roofing-pricing" data-testid="roofing-pricing-section">
      <div className="cursor-container roofing-pricing-inner">
        <p className="roofing-pricing-badge">{PRICING.badge}</p>
        <h2 className="roofing-pricing-title" data-testid="roofing-pricing-headline">
          {PRICING.headlineLead}{" "}
          <span className="roofing-pricing-gain">{PRICING.headlineAccent}</span>{" "}
          {PRICING.headlineTail}
        </h2>
        <p className="roofing-pricing-subhead" data-testid="roofing-pricing-subhead">
          {PRICING.subhead}
        </p>

        <div className="roofing-pricing-card" data-testid="roofing-pricing-tier">
          <h3 className="roofing-pricing-tier-title">{PRICING.tierTitle}</h3>
          <p className="roofing-pricing-amount">
            {amount ? (
              <>
                <span className="roofing-pricing-amount-value">{amount}</span>
                <span className="roofing-pricing-amount-period"> / month</span>
              </>
            ) : null}
          </p>
          <p className="roofing-pricing-price-note">{PRICING.priceNote}</p>
          <ul className="roofing-pricing-features">
            {PRICING.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="roofing-pricing-math" data-testid="roofing-pricing-math">
          <p className="roofing-pricing-math-title">{PRICING.mathTitle}</p>
          <div className="roofing-pricing-math-row">
            <span className="roofing-pricing-math-icon" aria-hidden="true">
              {PRICING.mathHuman.icon}
            </span>
            <div>
              <p className="roofing-pricing-math-label">{PRICING.mathHuman.label}</p>
              <p className="roofing-pricing-math-value">{PRICING.mathHuman.value}</p>
            </div>
          </div>
          <div className="roofing-pricing-math-row roofing-pricing-math-row-highlight">
            <span className="roofing-pricing-math-icon" aria-hidden="true">
              {PRICING.mathEmployee.icon}
            </span>
            <div>
              <p className="roofing-pricing-math-label">{PRICING.mathEmployee.label}</p>
              <p className="roofing-pricing-math-value">
                {amount ? `${amount}/mo ` : null}
                {PRICING.mathEmployee.valueSuffix}
              </p>
            </div>
          </div>
          <div className="roofing-pricing-math-row">
            <span className="roofing-pricing-math-icon" aria-hidden="true">
              {PRICING.mathRoi.icon}
            </span>
            <div>
              <p className="roofing-pricing-math-label">{PRICING.mathRoi.label}</p>
              <p className="roofing-pricing-math-value">{PRICING.mathRoi.value}</p>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="roofing-pricing-cta"
          onClick={onOpenModal}
          data-testid="roofing-pricing-cta"
        >
          <span>{PRICING.cta}</span>
          <span aria-hidden="true"> ↗</span>
        </button>
        <p className="roofing-pricing-disclosure" data-testid="roofing-pricing-disclosure">
          {PRICING.disclosure}
        </p>
        <p className="roofing-pricing-concierge" data-testid="roofing-pricing-concierge">
          {PRICING.conciergeNote}
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
